import { Navigate, Outlet, useLocation } from 'react-router'

/**
 * 가입 직후 권유 화면으로 넘길지 가르는 자리.
 *
 * 가입과 로그인이 같은 경로를 지나므로 화면이 스스로 가리지 못한다. 이번 왕복에서 계정이 섰다는
 * 표시를 Backend가 홈 주소에 붙여 보내고 그 표시가 이 화면을 연다. 연결 왕복이 막혀 돌아온
 * 경우도 같은 주소로 오므로 그 값도 함께 본다.
 *
 * 홈을 그리기 전에 가른다. 홈 레이아웃이 한 번 섰다가 넘어가면 헤더가 깜빡이고, 그 자리는
 * 권유 화면이 쓰지 않는 자리다.
 *
 * 추가를 마치고 돌아온 값은 넘기지 않는다. 하려던 일이 끝나 그 화면에 남은 할 일이 없고 홈이
 * 목록 위의 한 줄로 결과를 알린다.
 */
export function OnboardingGate() {
  const location = useLocation()

  if (location.pathname !== '/') return <Outlet />

  const params = new URLSearchParams(location.search)
  const welcomed = params.get('welcome') === '1'
  const returned = params.has('reason')
  if (!welcomed && !returned) return <Outlet />

  return <Navigate to={`/welcome${location.search}`} replace />
}
